import { Icon } from '@ipfabric/ui-components/Icon/Icon';
import { useLoadingState } from '@ipfabric/ui-components/hooks/useLoadingState';
import { withLoadingIndicator } from '@ipfabric/ui-components/utils/loading/withLoadingIndicator';
import type { FC } from 'react';
import { useHasPermission } from 'utils/permissions/useHasPermission';
import { GraphToolbarButton } from './GraphToolbarButton';

interface Props {
  disabled: boolean;
  onClick: () => Promise<void>;
}

export const GraphToolbarTechsupportButton: FC<Props> = ({
  disabled,
  onClick,
}) => {
  const hasPermission = useHasPermission();
  const [loadingState, setLoadingState] = useLoadingState();

  if (!hasPermission('settings')) {
    return null;
  }

  return (
    <GraphToolbarButton
      disabled={disabled || loadingState === 'LOADING'}
      onClick={async () => {
        await withLoadingIndicator(setLoadingState)(async () => {
          await onClick();
        });
      }}
      title='Generate techsupport for these devices'
    >
      <Icon glyph='fa-file-exclamation' loading={loadingState === 'LOADING'} />
    </GraphToolbarButton>
  );
};
